import Toolbar from "@mui/material/Toolbar";
import Head from "next/head";
import { Fragment } from "react";
import CompanyList from "../../components/companies/CompanyList/CompanyList";
import CompanySearchFilters from "../../components/companies/CompanySearchFilters/CompanySearchFilters";
import ToResolveClassNameError from "../../components/hoc/ToResolveClassNameError";
import SharedChat from "../../components/shared/SharedChat/SharedChat";
import SharedCollapsibleFooter from "../../components/shared/SharedCollapsibleFooter/SharedCollapsibleFooter";
import SharedNavbar2 from "../../components/shared/SharedNavbar/Navbar/Navbar";
import * as config from "../../config/config";
import { formCompanyQueryParam } from "../../functions/company";
import {
  convertCompanyUrlToIds,
  encodePage,
} from "../../helpers/filter_management";
import { getCompanyListWithoutRedux } from "../../redux/actions/company_action";

export default function CompanyFiltersPage(props) {
  const { ssrCompanyList, ssrFilterParams, ssrPageParams } = props;

  let metaTitle = "Find companies and jobs in Malaysia - Hiredly";
  let metaDescription =
    "Learn about the work environment, benefits & jobs of companies on Hiredly. View office location, employee experience, and start your career right.";

  return (
    <Fragment>
      <Head>
        {/* <!-- Primary Meta Tags --> */}
        <title>{metaTitle}</title>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />

        {/* <!-- Open Graph / Facebook --> */}
        <meta property="og:type" content="website" key={"ogType"} />
        <meta
          property="og:url"
          content="https://my.hiredly.com/companies"
          key="ogUrl"
        />
        <meta property="og:title" content={metaTitle} key="ogTitle" />
        <meta
          property="og:description"
          content={metaDescription}
          key="ogDescription"
        />
        <meta
          property="og:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="ogImage"
        />

        {/* <!-- Twitter --> */}
        <meta
          property="twitter:card"
          content="summary_large_image"
          key="twitterCard"
        />
        <meta
          property="twitter:url"
          content="https://my.hiredly.com/companies"
          key="twitterUrl"
        />
        <meta property="twitter:title" content={metaTitle} key="twitterTitle" />
        <meta
          property="twitter:description"
          content={metaDescription}
          key="twitterDescription"
        />
        <meta
          property="twitter:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="twitterImage"
        />
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        <link rel="canonical" href="https://my.hiredly.com/companies" />
      </Head>
      <ToResolveClassNameError>
        <SharedNavbar2 page="company-list-page" />
        <Toolbar />
        <CompanySearchFilters />
      </ToResolveClassNameError>
      <CompanyList
        serverCompanyList={ssrCompanyList}
        serverFilterParams={ssrFilterParams}
        serverPageParams={ssrPageParams}
      />
      <ToResolveClassNameError>
        <SharedCollapsibleFooter />
        <SharedChat />
      </ToResolveClassNameError>
    </Fragment>
  );
}

export async function getServerSideProps(context) {
  const { query } = context;

  const companyFilter = convertCompanyUrlToIds(query);

  const currentPage = encodePage(query?.page - 1, 20);

  const params = formCompanyQueryParam(companyFilter, true);

  const paginationParams = {
    first: 20,
    last: null,
    before: null,
    after: currentPage,
  };

  const combinedParams = {
    ...params,
    ...paginationParams,
  };

  const companies = await getCompanyListWithoutRedux(combinedParams);

  return {
    props: {
      ssrCompanyList: companies ?? [],
      ssrFilterParams: companyFilter ?? {},
      ssrPageParams: currentPage ?? null,
    },
  };
}
